import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { getLogout } from '../Api'

export default generateApiAction({
  baseType: Types.AUTH.LOGOUT,
  api: getLogout,
  responseType: RESPONSETYPE.EMPTY
})



// WEBPACK FOOTER //
// ./src/actions/auth/LogoutAction.js